module.exports = __webpack_public_path__ + "static/assets/25975891ecd8a6f4ef56f1ab478442cd.png";